import React from "react";
import { Routes } from "../../../../../common/Routes";
import { firstUpperCase, isNullOrUndefined } from "../../../../../common/utils";
import { formatUtcDateToLocal, parseDate } from "../../../../../common/utils/TimeUtils";
import { AuthZTable } from "../../../../../components/authZTable";
import { LinkSpan } from "../../../../../components/linkSpan";
import useGetUserGroupListForSelectedUser, {
  useCheckUserGroupListForSelectedUserIsLoaded
} from "../../hooks/GetUserGroupListForSelectedUser/GetUserGroupListForSelectedUser";
import { sendUserEvent, UserAction } from "../../../../../components/matomoClient";
import { Tag } from "antd";

function UserGroupList({ userGroupType }) {
  let { userGroups, userGroupScopeList } = useGetUserGroupListForSelectedUser();

  userGroups = userGroups.filter((userGroup) => {
    return userGroup.type === userGroupType.id;
  });

  userGroups = userGroups.map(userGroup => {
    const scope = userGroupScopeList.find(x => x.userGroupId === userGroup.id)?.scope ?? "";
    return {
      ...userGroup,
      scope: scope
    };
  });

  const columns = [
    {
      title: userGroupType.titleName,
      dataIndex: "name",
      sortEnabled: true,
      searchEnabled: true,
      render: (text, record) => (
        <LinkSpan
          keyId={record.id}
          to={`${Routes.UserGroups.basePath}/${userGroupType.uniqueName}/${record.uniqueName}`}
          text={text}
          matomoFn={() => {
            sendUserEvent(UserAction.UserGroupDetails);
          }}
        />
      )
    },
    {
      title: "Description",
      dataIndex: "description",
      sortEnabled: false,
      searchEnabled: false
    },
    {
      title: "Added by",
      dataIndex: "addedBy",
      sortEnabled: false,
      searchEnabled: false
    },
    {
      title: "Added on",
      dataIndex: "addedOn",
      render: (date) => {
        return (
          <>
            {isNullOrUndefined(date)
              ? null
              : formatUtcDateToLocal(
                  parseDate(date),
                  "YYYY-MM-DD HH:mm:ss"
                )}
          </>
        );
      },
      sortEnabled: false,
      searchEnabled: false,
    },
    {
      title: "Default access scope",
      dataIndex: "scope",
      key: "scope",
      render: (scope) => {
        const btScope = scope?.name ?? "";
        return firstUpperCase(btScope);
      },
      sortEnabled: true,
      searchEnabled: true
    },
    {
      title: "Status",
      dataIndex: "isPublished",
      key: "isPublished",
      render: (isPublished, record) => {
        return (
          <div className="flex-container">
            <div>
              {isPublished ? (
                <Tag className={"status-tag"} color="success">
                  Published
                </Tag>
              ) : (
                <Tag className={"status-tag"} color="default">
                  Draft
                </Tag>
              )}
            </div>
          </div>
        );
      },
      filters: [
        {
          "text": "Draft",
          "value": false
        },
        {
          "text": "Published",
          "value": true
        }
      ],
      filterMultiple: false,
      sortEnabled: false,
      searchEnabled: false,
      filterEnabled: true
    }
  ];

  const isLoading = useCheckUserGroupListForSelectedUserIsLoaded();
  
  return (
    <div>
      <AuthZTable
        rowKey="id"
        name="user-group-list"
        dataSource={userGroups}
        columns={columns}
        pagination={false}
        loading={isLoading}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}

export default UserGroupList;
